var map = {
	"./1.jpg": 125,
	"./2.jpg": 126,
	"./3.jpg": 127,
	"./4.jpg": 128,
	"./avicom-team-photo/1.jpg": 40,
	"./avicom-team-photo/2.jpg": 41,
	"./avicom-team-photo/3.jpg": 42,
	"./avicom-team-photo/4.jpg": 43,
	"./bgshape.png": 219,
	"./bgshape.svg": 124,
	"./brand/1.png": 146,
	"./brand/2.png": 147,
	"./brand/3.png": 148,
	"./brand/4.png": 149,
	"./brand/5.png": 150,
	"./brand/6.png": 151,
	"./brand/7.png": 152,
	"./brand/8.png": 153,
	"./brand/9.png": 154,
	"./client/1.jpg": 58,
	"./client/2.jpg": 59,
	"./client/3.jpg": 60,
	"./client/4.jpg": 61,
	"./cloud.svg": 138,
	"./cludeicon.png": 47,
	"./content/avicom-team.png": 88,
	"./content/avicom-team.svg": 220,
	"./content/chatbot.png": 90,
	"./content/esl.png": 89,
	"./data.png": 123,
	"./dhost.svg": 139,
	"./domain1.png": 98,
	"./domain2.png": 99,
	"./domain3.png": 100,
	"./domain4.png": 101,
	"./domain5.png": 102,
	"./domain6.png": 103,
	"./fast.png": 143,
	"./fast.svg": 221,
	"./favicon.png": 222,
	"./featured-img1.jpg": 45,
	"./featured-img2.jpg": 46,
	"./featured-img3.jpg": 48,
	"./featured-img4.jpg": 49,
	"./features-icons/it-consulting.svg": 81,
	"./features-icons/mobile-development.svg": 79,
	"./features-icons/software-development.svg": 80,
	"./features-icons/web-development.svg": 78,
	"./footer-logo.png": 223,
	"./ggmap.png": 224,
	"./headphone.svg": 137,
	"./hero-3.png": 225,
	"./hero-bg.svg": 144,
	"./lock.png": 141,
	"./logo.png": 226,
	"./logo.svg": 63,
	"./main-icons/005-chat.svg": 227,
	"./main-icons/_it.svg": 228,
	"./main-icons/digital-solutions.svg": 77,
	"./main-icons/digitalization.svg": 76,
	"./main-icons/it.svg": 75,
	"./mainserver.png": 140,
	"./map.png": 122,
	"./network.svg": 142,
	"./p1.svg": 155,
	"./p2.svg": 156,
	"./p3.svg": 157,
	"./review.png": 229,
	"./section-icon.png": 230,
	"./services-2/backup.png": 131,
	"./services-2/database.png": 132,
	"./services-2/fast.png": 133,
	"./services-2/privacy.png": 134,
	"./services-2/setup.png": 135,
	"./services-2/ssl.png": 136,
	"./services-icons/chatbot.svg": 82,
	"./services-icons/digitality.svg": 83,
	"./services-icons/esl.svg": 84,
	"./services-icons/innovations.svg": 85,
	"./services-icons/it-infrastructure.svg": 86,
	"./services-icons/modern-technologies.svg": 87,
	"./services/backup.png": 104,
	"./services/boost.png": 105,
	"./services/database.png": 106,
	"./services/fast.png": 107,
	"./services/fback.png": 108,
	"./services/fdata.png": 109,
	"./services/feasy.png": 110,
	"./services/ffast.png": 111,
	"./services/fpp.png": 112,
	"./services/fssl.png": 113,
	"./services/idea.png": 114,
	"./services/network.png": 115,
	"./services/privacy.png": 116,
	"./services/setup.png": 117,
	"./services/ssd.png": 118,
	"./services/ssl.png": 119,
	"./services/support.png": 120,
	"./services/wp.png": 121,
	"./shape/1.png": 50,
	"./shape/10.png": 33,
	"./shape/11.png": 34,
	"./shape/12.png": 35,
	"./shape/13.png": 36,
	"./shape/14.png": 37,
	"./shape/15.png": 38,
	"./shape/16.png": 39,
	"./shape/17.png": 21,
	"./shape/2.png": 51,
	"./shape/3.png": 52,
	"./shape/4.png": 53,
	"./shape/5.png": 54,
	"./shape/6.png": 55,
	"./shape/7.png": 56,
	"./shape/8.png": 57,
	"./shape/9.png": 32,
	"./shape/card-shape.png": 231,
	"./shape/circle.png": 232,
	"./sign.png": 158,
	"./slider1.png": 62,
	"./slider2.png": 129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 145;